import { message } from 'antd';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUser from '../user/userController';

const useForgetPageController = () => {
  const { requestReset } = useUser();
  const [email, setEmail] = useState<Email>('');
  const navigate = useNavigate();
  const [isPress, setIsPress] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const onPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsPress(true);
    }
  };

  const handleInputChange = (newValue: string) => {
    setEmail(newValue);
  };

  const onSendRequest = () => {
    if (email === '') {
      return async () => {
        message.error('Please fill in the email field.', 1);
      };
    }
    return () => requestReset(email!);
  };

  const goToLogin = async () => {
    navigate(-1);
  };

  return {
    email,
    handleInputChange,
    onPress,
    onSendRequest,
    isPress,
    goToLogin,
    buttonRef,
  };
};

export default useForgetPageController;
